import React from 'react';
import LayoutAdmin from '../../layouts/admin';
import UserManagementContent from '../../components/user_management';

const UserManagementPage = () => {
  return (
    <LayoutAdmin content={<UserManagementContent/>}/>
  );
}

export default UserManagementPage;